import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CoreModule } from 'src/app/core/core.module';
import { ResizableModule } from 'src/app/core/directive/resizable/resizable.module';
import { AngularMaterialModule } from 'src/app/shared/material-module';
import { DeploymentModule } from '../../deployment/deployment.module';
import { SharedModule } from '../../shared/shared.module';
import { ConfiguratorLeftPanelComponent } from './configurator-left-panel/configurator-left-panel.component';
import { ConfiguratorMainPanelComponent } from './configurator-main-panel/configurator-main-panel.component';
import { ConfiguratorRoutingModule } from './configurator-routing.module';
import { ConfiguratorSummaryComponent } from './configurator-summary/configurator-summary.component';
import { AddNodeConfiguratorComponent } from './node-configurator/add-node-configurator/add-node-configurator.component';
import { ListNodeConfiguratorComponent } from './node-configurator/list-node-configurator/list-node-configurator.component';
import { DeleteNodeConfiguratorComponent } from './node-configurator/modals/delete-node-configurator/delete-node-configurator.component';
import { UpdateNodeConfiguratorComponent } from './node-configurator/modals/update-node-configurator/update-node-configurator.component';
import { ServiceBroadcastComponent } from './service-broadcast/service-broadcast.component';

import { ThemeConfigComponent } from './theme-config/theme-config.component';
import { UpdateAuthenticationConfigurationComponent } from './update-authentication-configuration/update-authentication-configuration.component';
import { UpdateLoginUiConfiguratorComponent } from './update-login-ui-configurator/update-login-ui-configurator.component';
import { GpoListComponent } from './gpo-list/gpo-list.component';
import { UpdateGpoPropertiesComponent } from './gpo-list/update-gpo-properties/update-gpo-properties.component';
import { AddGpoComponent } from './gpo-list/add-gpo/add-gpo.component';
import { ImportNodeConfiguratorComponent } from './node-configurator/modals/import-node-configurator/import-node-configurator.component';
import { DynamicPaginationDirective } from 'src/app/core/directive/dynamicPagination/dynamic-pagination.directive';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';

@NgModule({
  declarations: [
    ConfiguratorMainPanelComponent,
    ConfiguratorLeftPanelComponent,
    ConfiguratorSummaryComponent,
    ListNodeConfiguratorComponent,
    AddNodeConfiguratorComponent,
    DeleteNodeConfiguratorComponent,
    UpdateNodeConfiguratorComponent,
    UpdateAuthenticationConfigurationComponent,
    UpdateLoginUiConfiguratorComponent,
    ServiceBroadcastComponent,
    ThemeConfigComponent,
    GpoListComponent,
    UpdateGpoPropertiesComponent,
    AddGpoComponent,
    ImportNodeConfiguratorComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    CoreModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    ConfiguratorRoutingModule,
    DeploymentModule,
    ResizableModule,
    NgxPaginationModule,
    SharedModule,
    NgbModule,
    DynamicPaginationDirective,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
  ],
})
export class ConfiguratorModule {}
